<script lang="ts">
	import TooltipChip, { ChipTone } from '$lib/atoms/badges/TooltipChip.svelte'
	import IconWarning from '$svg/icon-warning.svg?component'
	import { DangerKind, TooltipPlacements } from '$types/enums'
	import { t } from '$i18n/i18n'

	interface Props {
		/** every reason this value makes the material dangerous, nothing is rendered when empty */
		kinds: DangerKind[]
		placement?: TooltipPlacements
	}

	let { kinds, placement = TooltipPlacements.RIGHT }: Props = $props()

	const GLYPH_SIZE = 18

	const isRange = $derived(kinds.includes(DangerKind.RANGE))
	const isEcotoxic = $derived(kinds.includes(DangerKind.ECOTOXIC))

	const reason = $derived.by(() => {
		if (isRange && isEcotoxic) return $t('Analytics.danger.both.tooltip')
		if (isRange) return $t('Analytics.danger.range.tooltip')

		return $t('Analytics.danger.ecotoxic.tooltip')
	})
</script>

{#if kinds.length}
	<TooltipChip
		name="danger"
		tone={ChipTone.DANGER}
		title={$t('Analytics.danger.title')}
		{placement}
	>
		{#snippet icon()}
			<IconWarning width={GLYPH_SIZE} height={GLYPH_SIZE} />
		{/snippet}
		<!-- the translation emphasises the source of the limits with <b>, which only real markup keeps -->
		<span>{@html reason}</span>
	</TooltipChip>
{/if}
